// CustomDropdown.js
import React, { useState, useRef, useEffect } from 'react';
import IconCollection from '../../IconCollection/IconCollection';
import PropTypes from 'prop-types';

const CustomDropdown = ({ options, onChange, customStyle, customStyleDropdownList, liCustomStyle, defaultValue, dropdownContainer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(defaultValue || (options?.length > 0 ? options[0]?.value : null));
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    setSelectedValue(value);
    onChange(value);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={`custom-dropdown relative ${dropdownContainer}`} ref={dropdownRef}>
      <button className={`dropdown-header  ${customStyle}`} onClick={toggleDropdown}>
        {selectedValue || 'Select'}
        <i className={`arrow ${isOpen ? 'up' : 'down'}`} />
         {isOpen ? <IconCollection
          customClass='md:max-w-6 max-w-[10px] w-full md:h-6 h-[10px]'
          name="arrow-up" /> : <IconCollection
          customClass='md:max-w-6 max-w-[10px] w-full md:h-6 h-[10px]'
          name="arrow-down" />}
      </button>
      {isOpen && (
        <ul className={`dropdown-list z-[51]  ${customStyleDropdownList}`}>
          {options.map((option, index) => (
            <li
              className={` ${liCustomStyle} ${index === options.length - 1 ? 'border-none' : ''}`}
              key={index}
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

CustomDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  customStyle: PropTypes.string,
  customStyleDropdownList: PropTypes.string,
  liCustomStyle: PropTypes.string,
  defaultValue: PropTypes.string,
  dropdownContainer: PropTypes.string,
};

export default CustomDropdown;

